import { CheckmarkIcon } from "icons/checkmark-icon";
import { CrossIcon } from "icons/cross-icon";
import { ExclamationIcon } from "icons/exclamation-icon";
import { InfoIcon } from "icons/info-icon";
import React, { PropsWithChildren, ReactNode, useEffect, useRef } from "react";

import css from "./index.module.scss";

export type AlertType = "success" | "info" | "error" | "warning";

type Props = {
  className?: string;
  right?: ReactNode;
  scrollIntoView?: boolean;
  type: AlertType;
  withIcon?: boolean;
};

export const Alert = ({
  children,
  className,
  right,
  scrollIntoView = false,
  type,
  withIcon = true,
}: PropsWithChildren<Props>) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref.current && scrollIntoView) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [scrollIntoView]);

  return (
    <div className={[css.alertBox, css[type], className].join(" ")} ref={ref}>
      {withIcon && (
        <div className={css.iconBox}>
          {type === "success" && <CheckmarkIcon className={css.icon} />}
          {type === "info" && <InfoIcon className={css.icon} />}
          {type === "error" && <CrossIcon className={css.icon} />}
          {type === "warning" && <ExclamationIcon className={css.icon} />}
        </div>
      )}
      <div className={css.message}>{children}</div>
      {right}
    </div>
  );
};
